import {
  FormControl,
  Select,
  MenuItem,
  Skeleton,
  ListItemIcon,
  Box,
  Tooltip,
} from '@mui/material';
import { memo } from 'react';
import CheckIcon from '@mui/icons-material/Check';

export const TeamSelector = memo(
  ({ teams, selectedTeam, setSelectedTeam, teamBlocksCount, classes }) =>
    selectedTeam ? (
      <FormControl>
        <Select
          labelId="teamSelector-label"
          id="teamSelector"
          value={selectedTeam?.uuid}
          onChange={(e) =>
            setSelectedTeam(teams.find(({ uuid }) => uuid === e.target.value))
          }
          renderValue={(value) => {
            const team = teams.find(({ uuid }) => uuid === value);

            return team?.name || '';
          }}
          MenuProps={{
            PaperProps: {
              style: {
                minWidth: '20rem',
                whiteSpace: 'nowrap',
              },
            },
          }}
        >
          {teams?.map((team) => {
            const isTeamSelected = selectedTeam?.uuid === team.uuid;
            const menuItemClassName = `${classes.teamMenuItem} ${
              isTeamSelected ? classes.teamMenuItemSelected : ''
            }`;

            return (
              <MenuItem
                key={team.uuid}
                value={team.uuid}
                className={menuItemClassName}
              >
                <Tooltip title={team.name} placement="top">
                  <Box className={classes.teamMenuItemText}>
                    {isTeamSelected && (
                      <ListItemIcon className={classes.teamSelectedIcon}>
                        <CheckIcon />
                      </ListItemIcon>
                    )}
                    {team.name}{' '}
                  </Box>
                </Tooltip>
                <Box>{teamBlocksCount[team.uuid] || 0}</Box>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    ) : (
      <Skeleton variant="rectangular" width={125.2} height={26.25} />
    ),
);

TeamSelector.displayName = 'TeamSelector';
